// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"9cfb7b78","411":"65e40205","516":"adfefc61","616":"56b9ca33","698":"ea75851d","730":"8429b9ea","917":"b50d64a1","934":"2c97c959"}[chunkId] + ".chunk.css";
};